import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export default makeStyles()(() => ({
  modalTextBox: {
    paddingRight: Tokens.spacing['$sp-2-5'],
    marginBottom: Tokens.spacing['$sp-5']
  },
  modalFormContent: {
    display: 'flex',
    alignItems: 'center'
  },
  globalRoleWrap: {
    marginTop: Tokens.spacing['$sp-4'],
  },
  dropDown: {
    marginTop: Tokens.spacing['$sp-4'],
  }
}));